import { render, staticRenderFns } from "./DashboardCardTitle.vue?vue&type=template&id=1f003244&scoped=true&"
import script from "./DashboardCardTitle.vue?vue&type=script&lang=js&"
export * from "./DashboardCardTitle.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardTitle.vue?vue&type=style&index=0&id=1f003244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f003244",
  null
  
)

export default component.exports